import styled from 'styled-components'

const ResponsiveSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0;
  margin: 20px auto;
  max-width: ${props => props.theme.metrics.contentMaxWidth}px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    margin: 60px auto;
    flex-direction: row;
  }
`
const TextContainer = styled.div`
  flex: 1;
  padding: 10px;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding-right: 20px;
  }
`

const Subhead = styled.h3`
  font-size: 2em;
  margin-bottom: 10px;
`

const BodyText = styled.p`
  font-size: 1.2em;
  line-height: 1.6em;
  margin-bottom: 20px;
`

const BulletListContainer = styled.div`
  flex: 1;
  padding: 10px;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding-left: 20px;
  }
`

const BulletList = styled.ul`
  list-style-type: disc;
  padding: 0 20px;
`

const BulletItem = styled.li`
  font-size: 16px;
  padding-bottom: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  &::before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    background-color: ${props => props.theme.colors.blue4};
    mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M9 16.2l-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4z"/></svg>')
      no-repeat center;
    mask-size: contain;
  }
`

const SmartBuyersSection = () => (
  <ResponsiveSection>
    <TextContainer>
      <Subhead>Smart Buyers Deserve Smart Savings</Subhead>
      <BodyText>
        Access everything you need to purchase your next property while receiving a significant
        portion of your agent’s commission back at closing. Whether you’re downsizing for retirement
        or expanding your investment portfolio, find out how much you could save with HomeLister’s
        commission-sharing program. Our buyers have received <strong>over $20,000 back</strong> at
        closing, with exact amounts varying by state and purchase price*. The services offered are
        fulfilled by Trelora Realty, Newfound and/or Houwzer, licensed real estate brokerages in
        their respective states.
      </BodyText>
    </TextContainer>
    <BulletListContainer>
      <BulletList>
        <BulletItem>Receive a portion of your agent’s commission back at closing</BulletItem>
        <BulletItem>Full MLS access and showing services when you need them</BulletItem>
        <BulletItem>Offset today’s high rates or increase your down payment</BulletItem>
        <BulletItem>Experienced agents available for guidance, but you’re in control</BulletItem>
        <BulletItem>Cancel anytime before going under contract</BulletItem>
        <BulletItem>Make stronger offers with our competitive commission structure</BulletItem>
      </BulletList>
    </BulletListContainer>
  </ResponsiveSection>
)

export default SmartBuyersSection
